import { type VariantProps, cva } from "class-variance-authority";
import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../lib/utils";
import { Typography } from "./typography";

const inlineFeedbackVariants = cva("inline-flex py-2 font-poppins", {
  variants: {
    variant: {
      critical: "text-pink-600",
      alert: "text-orange-500",
      info: "text-gray-700",
    },
    nested: {
      true: "py-0",
      false: "",
    },
  },
  defaultVariants: {
    variant: "info",
    nested: false,
  },
});

export interface InlineFeedbackProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof inlineFeedbackVariants> {
  message: string;
}

export const InlineFeedback = ({
  variant = "info",
  message,
  className,
  nested = false,
  ...props
}: InlineFeedbackProps) => {
  return (
    <div
      className={cn(inlineFeedbackVariants({ variant, nested }), className)}
      role="alert"
      {...props}
    >
      <Typography>{message}</Typography>
    </div>
  );
};

InlineFeedback.displayName = "InlineFeedback";

export interface InlineFeedbackGroupProps
  extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export const InlineFeedbackGroup = ({
  children,
  className,
  ...props
}: InlineFeedbackGroupProps) => {
  return (
    <div className={cn("py-2 flex flex-col", className)} {...props}>
      {children}
    </div>
  );
};

InlineFeedbackGroup.displayName = "InlineFeedbackGroup";
